import { PersonalityFormValues } from "./PersonalityTest";

export const PERSONALITY_TEST_FORM_DATA_SESSION_STORAGE_KEY = "personalityTestFormData";

export const savePersonalityTestFormData = (formData: PersonalityFormValues): void => {
  sessionStorage.setItem(PERSONALITY_TEST_FORM_DATA_SESSION_STORAGE_KEY, JSON.stringify(formData));
};

export const getPersonalityTestFormData = (): PersonalityFormValues | null => {
  const savedData = sessionStorage.getItem(PERSONALITY_TEST_FORM_DATA_SESSION_STORAGE_KEY);

  if (!savedData) return null;

  try {
    const parsedData = JSON.parse(savedData) as PersonalityFormValues;
    return parsedData;
  } catch (error) {
    console.error("Error parsing personality test form data from session storage:", error);
    return null;
  }
};

export const hasPersonalityTestFormData = (): boolean => {
  const hasData = sessionStorage.getItem(PERSONALITY_TEST_FORM_DATA_SESSION_STORAGE_KEY) !== null;
  return hasData;
};

export const removePersonalityTestFormData = (): void => {
  sessionStorage.removeItem(PERSONALITY_TEST_FORM_DATA_SESSION_STORAGE_KEY);
};
